import type { SVGProps } from "react";
const SenecPictogramMagazine = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 9C8 8.44772 8.44771 8 9 8H31C31.5523 8 32 8.44772 32 9V35C32 35.5523 31.5523 36 31 36H9C8.44772 36 8 35.5523 8 35V34C8 33.4477 7.55228 33 7 33C6.44772 33 6 33.4477 6 34V35C6 36.6569 7.34315 38 9 38H14V39C14 40.6569 15.3431 42 17 42H39C40.6569 42 42 40.6569 42 39V13C42 11.3431 40.6569 10 39 10H34V9C34 7.34315 32.6569 6 31 6H9C7.34315 6 6 7.34314 6 9V29C6 29.5523 6.44772 30 7 30C7.55228 30 8 29.5523 8 29V9ZM16 39V38H31C32.6569 38 34 36.6569 34 35V12H39C39.5523 12 40 12.4477 40 13V39C40 39.5523 39.5523 40 39 40H17C16.4477 40 16 39.5523 16 39Z"
            fill="currentColor"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M21 10H29V18H21V10ZM27 12H23V16H27V12Z" fill="currentColor" />
        <path
            d="M12 17C12 17.5523 11.5523 18 11 18C10.4477 18 10 17.5523 10 17C10 16.4477 10.4477 16 11 16C11.5523 16 12 16.4477 12 17Z"
            fill="currentColor"
        />
        <path
            d="M11 13C10.4477 13 10 13.4477 10 14C10 14.5523 10.4477 15 11 15C12.1046 15 13 15.8954 13 17C13 17.5523 13.4477 18 14 18C14.5523 18 15 17.5523 15 17C15 14.7909 13.2091 13 11 13Z"
            fill="currentColor"
        />
        <path
            d="M10 11C10 10.4477 10.4477 10 11 10C14.866 10 18 13.134 18 17C18 17.5523 17.5523 18 17 18C16.4477 18 16 17.5523 16 17C16 14.2386 13.7614 12 11 12C10.4477 12 10 11.5523 10 11Z"
            fill="currentColor"
        />
        <path d="M10 25H20.9996V23H10V25Z" fill="currentColor" />
        <path d="M10 29H30V27H10V29Z" fill="currentColor" />
        <path d="M10 33H30V31H10V33Z" fill="currentColor" />
    </svg>
);
export default SenecPictogramMagazine;
